import type { ReactNode } from "react";
import Button from "ui/buttons/Button";
import Modal, { type ModalProps } from "ui/components/Modal";
import { Message } from "ui/text/Message";

interface BuilderOptionModalProps extends ModalProps {
  modalBody: ReactNode;
  modalHeader: string;
  modalSubheader?: ReactNode;
  submittable: boolean;
  onSubmit: () => void;
  preventCloseOnSubmit?: boolean;
  submitButtonText?: string;
}

export default function BuilderOptionModal({
  open,
  onClose,
  modalBody,
  modalHeader,
  modalSubheader,
  submittable,
  onSubmit,
  preventCloseOnSubmit,
  submitButtonText = "Submit",
}: BuilderOptionModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={modalHeader}
      size="small"
      variants={["footerButtons", "bodyPadding"]}
      footer={
        <>
          {" "}
          <Button btnSize="large" type="button" btnStyle="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button btnSize="large" type="submit" disabled={!submittable} form="builder-option-modal">
            {submitButtonText}
          </Button>
        </>
      }
    >
      <form
        id="builder-option-modal"
        onSubmit={(e) => {
          e.preventDefault();
          if (submittable) {
            onSubmit();

            if (!preventCloseOnSubmit) {
              onClose?.();
            }
          }
        }}
      >
        {modalSubheader && <Message marginBottom>{modalSubheader}</Message>}
        {modalBody}
      </form>
    </Modal>
  );
}
